import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { TipsData } from '../me-tips.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';

@Component({
    selector: 'app-me-tips-dialog',
    templateUrl: './me-tips-dialog.component.html',
    styleUrls: ['./me-tips-dialog.component.less'],
    standalone: false
})
export class MeTipsDialogComponent implements OnInit {
  
  label!: string;
  tipsMessage!: string[];
  tipsStyle! : string[];
  externalSettings!: ExternalSettings;
  UIUtilityService: any = UIUtilityService;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TipsData,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService
  ) {}

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((externalSettings) => {
      this.externalSettings = externalSettings;
      this.label = this.data.label;
      this.tipsMessage = this.data.tipsMessage;
      this.tipsStyle = this.data.tipsStyle ? this.data.tipsStyle : [];
    });
  }

  public getClass(index : number) : string {
    if (this.tipsStyle[index] !== 'undefined') {
      return this.tipsStyle[index];
    }
    return '';
  }
}

